import { render } from "./CompareList.vue?vue&type=template&id=087bf702"
import script from "./CompareList.vue?vue&type=script&lang=js"
export * from "./CompareList.vue?vue&type=script&lang=js"

import exportComponent from "/home/uatcomp/public_html/wizards/travel-insurance-wizard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__